import styled from "styled-components"
import Image from "gatsby-image"

export const Wrap = styled.div`
  height: 100%;
  width: 65%;
  flex-direction: column;
  text-align: left;

  position: relative;
  margin: 0 0 0 35%;

  @media screen and (max-width: 979px) {
    width: 100%;
    margin: 0;
  }
`
export const Center = styled.div`
  width: 90%;
  margin: -3.5em auto;
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 992px) {
    width: 95%;
  }
`
export const ProjectDiv = styled.div`
  box-shadow: 0 15px 30px 1px rgba(128, 128, 128, 0.31);
  background: rgba(255, 255, 255, 0.9);
  text-align: center;
  border-radius: 5px;
  overflow: hidden;
  margin: 5em auto;
  height: 360px;
  width: 100%;
  max-width: 700px;

  @media screen and (max-width: 580px) {
    height: 100vh;
    width: 90%;
  }
`
export const Details = styled.div`
  position: relative;
  text-align: center;
  /* overflow: hidden; */
  padding: 2em;
  height: 100%;
  float: left;
  width: 50%;
  background: rgba(231, 231, 231, 0.9);

  h1 {
    font-family: "Quicksand", sans-serif;
    font-weight: 450;
    font-size: 1.4em;
    display: inline-block;
    position: relative;
    color: #344055;
    margin: 0 0 0.5em 0;
  }

  p {
    font-family: "Quicksand", sans-serif;
    font-weight: 300;
    font-size: 1em;
    text-align: center;
    color: #344055;
    margin-top: 0.6em;
    margin-bottom: 1em;
  }

  ul {
    float: bottom;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }

  a {
    padding: 0.5rem 0.5rem;
    font-size: 2rem;
    color: #344055;
    transition: var(--transition);

    &:hover {
      color: var(--clr-primary-5);
      font-size: 2.4rem;
    }
  }

  @media screen and (max-width: 580px) {
    height: 50%;
    float: none;
    width: 100%;
  }
`
export const Stack = styled.div`
  position: relative;
  bottom: 2%;

  span {
    display: inline-block;
    background: var(--clr-grey-9);
    color: var(--clr-grey-5);
    margin-right: 0.3rem;
    margin-bottom: 0.4rem;
    padding: 0.25rem 0.25rem;
    border-radius: var(--radius);
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 0.65rem;
  }

`
export const ImageDiv = styled.div`
  transition: all 0.3s ease-out;
  display: inline-block;
  position: relative;
  overflow: hidden;
  height: 100%;
  float: right;
  width: 50%;
  @media screen and (max-width: 580px) {
    height: 50%;
    float: none;
    width: 100%;
  }
`

export const ProjectImage = styled(Image)`
  width: 100%;
  height: 100%;

  &:hover {
    transition: all 0.3s ease-out;
    transform: scale(1.2, 1.2);
  }
`
